import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { USER_DATA } from '../types/user.js';
import { AUDIT_FIELD, AuditFieldLevelValues, } from '../types/audit.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/** JSON value payload — generous; not shown in forms. */
const AUDIT_JSON_MAX = 100000;
/**
 * Append-only field-audit line (spec 0046 / request 0249).
 * Filter columns are denormalized on purpose (/pg has no join).
 * Actor (`userId` / `at`) is stamped by system-api.
 */
export const auditFieldDescriptor = {
    name: AUDIT_FIELD,
    label: 'Campo de auditoria',
    domain: 'audit',
    collectionPath: 'org/{orgId}/audit-field',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Append-only log of one field change under an AuditOperation',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'append-only',
    indexes: [
        { fields: ['at'] },
        { fields: ['aggregateEntity', 'at'] },
        { fields: ['fieldName', 'at'] },
    ],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'operationId',
            label: 'Operação',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'groupId',
            label: 'Grupo',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'entity',
            label: 'Entidade',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ENTITY_NAME,
        },
        {
            name: 'recordId',
            label: 'Registro',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'aggregateEntity',
            label: 'Agregado (entidade)',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ENTITY_NAME,
        },
        {
            name: 'aggregateId',
            label: 'Agregado',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'aggregateLabel',
            label: 'Rótulo do agregado',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.DESCRIPTION,
        },
        {
            name: 'fieldName',
            label: 'Campo',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
        },
        {
            name: 'fieldLabel',
            label: 'Rótulo',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
        },
        {
            name: 'level',
            label: 'Nível',
            type: 'enum',
            required: true,
            enumValues: [...AuditFieldLevelValues],
        },
        {
            name: 'oldValueJson',
            label: 'Valor anterior',
            type: 'string',
            required: false,
            maxLength: AUDIT_JSON_MAX,
            description: 'JSON string — not type object (PG jsonb trap)',
        },
        {
            name: 'newValueJson',
            label: 'Valor novo',
            type: 'string',
            required: false,
            maxLength: AUDIT_JSON_MAX,
            description: 'JSON string — not type object (PG jsonb trap)',
        },
        {
            name: 'userId',
            label: 'Usuário',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        { name: 'at', label: 'Quando', type: 'date', required: true },
    ],
    foreignKeys: [
        {
            fieldName: 'operationId',
            targetEntity: 'AuditOperation',
            relationship: 'many-to-one',
            displayField: 'id',
            expand: false,
        },
        {
            fieldName: 'userId',
            targetEntity: USER_DATA,
            relationship: 'many-to-one',
            displayField: 'name',
            expand: false,
        },
    ],
};
//# sourceMappingURL=audit-field.descriptor.js.map